import { Flex, HTMLChakraProps, MenuListProps } from '@chakra-ui/react';
import { ConnectButton } from '@rainbow-me/rainbowkit';

import NetworkDropDown from './NetworkDropDown';
import WalletDropDown from './WalletDropDown';

const CustomConnectButton = ({ ...rest }: MenuListProps) => {
  return (
    <ConnectButton.Custom>
      {({ account, chain, openConnectModal, mounted }) => {
        const ready = mounted;
        const connected = ready && !!account && !!chain;
        return (
          <Flex gap={3}>
            <NetworkDropDown chain={chain} {...rest} />
            <WalletDropDown
              isConnected={connected}
              account={account}
              openConnectModal={openConnectModal}
              {...rest}
            />
          </Flex>
        );
      }}
    </ConnectButton.Custom>
  );
};
export default CustomConnectButton;
